// src/hooks/jobOrders/useGetProgramJobOrders.js
import { useQuery } from "@tanstack/react-query";
import { getProgramJobOrders } from "../../api/apiJobOrders";

const useGetProgramJobOrders = (programId) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["job-orders", programId],
        queryFn: () => getProgramJobOrders(programId),
        enabled: !!programId,
    });

    return {
        data: data?.data || null,
        error,
        isLoading,
        refetch
    };
};

export default useGetProgramJobOrders;
